import { render, staticRenderFns } from "./bomPop.vue?vue&type=template&id=b28ec98e"
import script from "./bomPop.vue?vue&type=script&lang=js"
export * from "./bomPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b28ec98e')) {
      api.createRecord('b28ec98e', component.options)
    } else {
      api.reload('b28ec98e', component.options)
    }
    module.hot.accept("./bomPop.vue?vue&type=template&id=b28ec98e", function () {
      api.rerender('b28ec98e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/material/bomPop.vue"
export default component.exports